import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';

export interface ILoaderState {
  status?: ActionStatus;
  isLoading: boolean;
}

const initialState: ILoaderState = {
  isLoading: false
};

export default function loaderReducer(state = initialState, action: {status: ActionStatus}): ILoaderState {
  switch (action.status) {
    case ActionStatus.Pending:
      return {...state, isLoading: true};
    case ActionStatus.Success:
    case ActionStatus.Failure:
      return {...state, isLoading: false};
    default:
      return state;
  }
}
